import { BlockTitles } from '@/components/BlockTitles'
import type BlockTitlesProps from '@/components/BlockTitles/types'
import { withContainer } from '@/hocs/withContainer'

import ReviewForm from './ReviewForm'

export interface BlogReviewFormProps extends BlockTitlesProps {}

const BlogReviewForm = ({ title, subtitle, colorModifier }: BlogReviewFormProps) => (
  <>
    <BlockTitles title={title} subtitle={subtitle} colorModifier={colorModifier} />
    <ReviewForm />
  </>
)

export default withContainer(BlogReviewForm, { spaceOut: 'm', className: 'eu-sp-m' })
